<template>
    <div class="box">
        <div v-if="!hideHeader" class="head">
            <div>
                <div class="title">
                    <slot name="title">{{title}}</slot>
                </div>
                <slot name="right" />
            </div>
        </div>
        <div class="body">
            <slot>这里是内容</slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Panel',
        props: {
            title: {
                type: String,
                default: '标题',
            },
            hideHeader: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped lang="less">
    .box {
        margin: 0 0 18px 0;
        background-color: #ffffff;
        border-radius: 12px;
        overflow: hidden;

        .head {
            padding: 0 18px;

            & > div {
                height: 4rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #f1f1f1;

                .title {
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .body {
            min-height: 3rem;
            padding: 18px;
        }
    }
</style>
